(function () {
  // Prevent double-init (theme editor reloads, app embeds, etc.)
  if (window.__EmailConciergeInitialized) return;
  window.__EmailConciergeInitialized = true;

  const initFormSpamDefense = () => {
    const traps = document.querySelectorAll('[data-form-spam-defense]');
    if (!traps.length) return;

    const stateByForm = new WeakMap();
    const now = () => Date.now();
    const storagePrefix = 'diamondpans:form-spam:';

    const getForm = (target) => {
      if (!target) return null;
      if (target.tagName === 'FORM') return target;
      return target.closest?.('form') || null;
    };

    const getTrap = (form) => form?.querySelector?.('[data-form-spam-defense]') || null;

    const getConfig = (trap) => ({
      type: trap.dataset.formSpamType || 'public',
      honeypotName: trap.dataset.formSpamHoneypot || 'company_url',
      minMs: Number(trap.dataset.formSpamMinMs) || 1800,
      rateLimit: Number(trap.dataset.formSpamRateLimit) || 3,
      rateWindowMs: Number(trap.dataset.formSpamRateWindowMs) || 600000,
      messageField: trap.dataset.formSpamMessageField || '',
      minMessageChars: Number(trap.dataset.formSpamMinMessageChars) || 0,
      maxUrls: Number(trap.dataset.formSpamMaxUrls) || 0,
    });

    const getState = (form) => {
      let state = stateByForm.get(form);
      if (!state) {
        state = { startedAt: now(), interacted: false };
        stateByForm.set(form, state);
      }
      return state;
    };

    const resetForm = (form) => {
      if (!form || !getTrap(form)) return;
      stateByForm.set(form, { startedAt: now(), interacted: false });
    };

    const setMessage = (trap, message) => {
      const messageEl = trap.querySelector('[data-form-spam-message]');
      if (!messageEl) return;

      messageEl.hidden = !message;
      messageEl.textContent = message || '';
    };

    const getFieldByName = (form, name) =>
      Array.from(form.elements || []).find((field) => field.name === name) || null;

    const normalizeMessage = (value) =>
      String(value || '')
        .replace(/[ \t]{2,}/g, ' ')
        .replace(/[ \t]+\n/g, '\n')
        .replace(/\n{3,}/g, '\n\n')
        .trim();

    const countUrls = (value) => (String(value || '').match(/\b(?:https?:\/\/|www\.)\S+/gi) || []).length;

    const getStoredAttempts = (key, windowMs) => {
      try {
        const cutoff = now() - windowMs;
        return (JSON.parse(localStorage.getItem(key) || '[]') || []).filter((ts) => Number(ts) > cutoff);
      } catch (e) {
        return null;
      }
    };

    const recordAttempt = (key, attempts) => {
      try {
        localStorage.setItem(key, JSON.stringify([...attempts, now()]));
      } catch (e) {}
    };

    traps.forEach((trap) => {
      const form = trap.closest('form');
      if (form) getState(form);
    });

    ['input', 'focusin', 'keydown', 'pointerdown', 'touchstart'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        (event) => {
          const form = getForm(event.target);
          if (!form || !getTrap(form)) return;

          getState(form).interacted = true;
        },
        true
      );
    });

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        const trap = getTrap(form);
        if (!trap) return;

        const config = getConfig(trap);
        const state = getState(form);
        const honeypot = getFieldByName(form, config.honeypotName);

        if ((honeypot?.value || '').trim()) {
          event.preventDefault();
          return;
        }

        if (now() - state.startedAt < config.minMs) {
          event.preventDefault();
          setMessage(trap, 'Please wait a moment and try again.');
          return;
        }

        if (!state.interacted) {
          event.preventDefault();
          setMessage(trap, 'Please fill out the form before submitting.');
          return;
        }

        if (config.messageField) {
          const messageField = getFieldByName(form, config.messageField);
          const cleaned = normalizeMessage(messageField?.value || '');

          if (messageField) messageField.value = cleaned;

          if (config.minMessageChars && cleaned.length < config.minMessageChars) {
            event.preventDefault();
            setMessage(trap, 'Please add a little more detail and try again.');
            return;
          }

          if (config.maxUrls && countUrls(cleaned) > config.maxUrls) {
            event.preventDefault();
            setMessage(trap, 'Please remove extra links and try again.');
            return;
          }
        }

        const storageKey = `${storagePrefix}${config.type}`;
        const attempts = getStoredAttempts(storageKey, config.rateWindowMs);
        if (attempts && attempts.length >= config.rateLimit) {
          event.preventDefault();
          setMessage(trap, 'Please wait a few minutes before sending another submission.');
          return;
        }

        if (attempts) recordAttempt(storageKey, attempts);
        setMessage(trap, '');
      },
      true
    );

    window.__FormSpamDefenseReset = resetForm;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormSpamDefense, { once: true });
  } else {
    initFormSpamDefense();
  }

  const drawer = document.querySelector('[data-email-concierge-drawer]');
  if (!drawer) return;

  const parseMailto = (href) => {
    // mailto:to@domain.com?subject=...&body=...
    const out = { to: '', subject: '', body: '' };
    try {
      const raw = String(href || '');
      const [schemePart, queryPart] = raw.split('?');
      out.to = schemePart.replace(/^mailto:/i, '').trim();

      if (queryPart) {
        const params = new URLSearchParams(queryPart);
        out.subject = params.get('subject') || '';
        out.body = params.get('body') || '';
      }
    } catch (e) {}
    return out;
  };

  let drawerApi = null;

  const getDrawerApi = () => {
    if (drawerApi) return drawerApi;

    const panel = drawer.querySelector('.email-concierge__panel');
    const contextBox = drawer.querySelector('[data-email-concierge-context]');
    const contextProduct = drawer.querySelector('[data-email-concierge-context-product]');
    const contextVariant = drawer.querySelector('[data-email-concierge-context-variant]');

    const fields = {
      source: drawer.querySelector('[data-email-concierge-field="source"]'),
      page_url: drawer.querySelector('[data-email-concierge-field="page_url"]'),
      product_title: drawer.querySelector('[data-email-concierge-field="product_title"]'),
      product_url: drawer.querySelector('[data-email-concierge-field="product_url"]'),
      variant_title: drawer.querySelector('[data-email-concierge-field="variant_title"]'),
      variant_sku: drawer.querySelector('[data-email-concierge-field="variant_sku"]'),
      variant_id: drawer.querySelector('[data-email-concierge-field="variant_id"]'),
    };

    // Capture Liquid-rendered defaults once so we can safely reset each open.
    const defaults = {};
    Object.keys(fields).forEach((k) => {
      defaults[k] = fields[k]?.value || '';
    });

    // Build variant map if Liquid provided it (product pages only).
    const variantMap = new Map();
    const variantJsonEl = drawer.querySelector('[data-email-concierge-variants-json]');
    if (variantJsonEl) {
      try {
        const variants = JSON.parse(variantJsonEl.textContent || '[]');
        variants.forEach((v) => variantMap.set(String(v.id), v));
      } catch (e) {
        // If JSON is malformed, we just won't enrich title/sku.
      }
    }

    let lastActive = null;
    let closeTimer = null;

    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

    // Message field (drawer textarea). Used to prefill from mailto: subject/body.
    const bodyField = drawer.querySelector('[name="contact[body]"]');

    const prefillMessageFromMailto = (mailto) => {
      if (!bodyField) return;

      // Don't overwrite if customer already typed something.
      if ((bodyField.value || '').trim().length) return;

      const lines = [];
      if (mailto.subject) lines.push(`Subject: ${mailto.subject}`);
      if (mailto.body) lines.push(mailto.body);

      if (lines.length) bodyField.value = lines.join('\n\n');
    };

    const getFocusable = () =>
      panel.querySelectorAll(
        'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
      );

    const lockScroll = (lock) => {
      document.documentElement.classList.toggle('email-concierge-lock', lock);
      document.body.classList.toggle('email-concierge-lock', lock);
    };

    const parseTimeListToMs = (csv) => {
      // "0.24s, 0s" -> 240
      return (csv || '')
        .split(',')
        .map((s) => s.trim())
        .map((val) => {
          if (!val) return 0;
          if (val.endsWith('ms')) return Number(val.replace('ms', '')) || 0;
          if (val.endsWith('s')) return (Number(val.replace('s', '')) || 0) * 1000;
          return Number(val) || 0;
        });
    };

    const getTransitionMs = (el) => {
      if (prefersReducedMotion) return 0;
      const style = window.getComputedStyle(el);
      const durations = parseTimeListToMs(style.transitionDuration);
      const delays = parseTimeListToMs(style.transitionDelay);
      const maxLen = Math.max(durations.length, delays.length, 1);

      let max = 0;
      for (let i = 0; i < maxLen; i++) {
        const d = durations[i] ?? durations[durations.length - 1] ?? 0;
        const l = delays[i] ?? delays[delays.length - 1] ?? 0;
        max = Math.max(max, d + l);
      }
      return Math.round(max);
    };

    const setField = (key, value) => {
      const el = fields[key];
      if (!el) return;

      if (value === undefined || value === null) {
        el.value = defaults[key] || '';
      } else {
        el.value = String(value);
      }
    };

    const updateContextPreview = () => {
      if (!contextBox) return;

      const pt = fields.product_title?.value || '';
      const vt = fields.variant_title?.value || '';
      const vs = fields.variant_sku?.value || '';

      if (!pt) {
        contextBox.hidden = true;
        return;
      }

      contextBox.hidden = false;
      if (contextProduct) contextProduct.textContent = pt;

      if (contextVariant) {
        const parts = [];
        if (vt) parts.push(vt);
        if (vs) parts.push(`SKU: ${vs}`);
        contextVariant.textContent = parts.join(' • ');
      }
    };

    const findCurrentVariantIdInput = (triggerEl) => {
      // 1) If trigger is inside a form (likely below CTA), use that.
      const closestForm = triggerEl?.closest?.('form');
      if (closestForm) {
        const input = closestForm.querySelector('input[name="id"]');
        if (input) return input;
      }

      // 2) Otherwise, use the first add-to-cart form on the page.
      return document.querySelector('form[action*="/cart/add"] input[name="id"]');
    };

    const fillVariantFromPageState = (triggerEl) => {
      const idInput = findCurrentVariantIdInput(triggerEl);
      const vid = idInput?.value ? String(idInput.value) : '';
      if (!vid) return;

      setField('variant_id', vid);

      if (variantMap.size && variantMap.has(vid)) {
        const v = variantMap.get(vid);
        setField('variant_title', v.title || '');
        setField('variant_sku', v.sku || '');
      }
    };

    const fillFromTrigger = (triggerEl) => {
      // Always reset to defaults first (prevents stale values).
      Object.keys(fields).forEach((k) => setField(k, undefined));

      // Always set runtime page URL.
      setField('page_url', window.location.href);

      // Always set a source.
      const source = triggerEl?.dataset?.emailConciergeSource || 'unknown';
      setField('source', source);

      // Trigger-provided product context (homepage tiles etc.)
      const ds = triggerEl?.dataset || {};
      if ('emailConciergeProductTitle' in ds) setField('product_title', ds.emailConciergeProductTitle || '');
      if ('emailConciergeProductUrl' in ds) setField('product_url', ds.emailConciergeProductUrl || '');
      if ('emailConciergeVariantId' in ds) setField('variant_id', ds.emailConciergeVariantId || '');
      if ('emailConciergeVariantTitle' in ds) setField('variant_title', ds.emailConciergeVariantTitle || '');
      if ('emailConciergeVariantSku' in ds) setField('variant_sku', ds.emailConciergeVariantSku || '');

      // If trigger did not explicitly provide variant details, enrich from current PDP selection.
      const triggerProvidedVariant =
        (ds.emailConciergeVariantId && String(ds.emailConciergeVariantId).length) ||
        (ds.emailConciergeVariantTitle && String(ds.emailConciergeVariantTitle).length) ||
        (ds.emailConciergeVariantSku && String(ds.emailConciergeVariantSku).length);

      if (!triggerProvidedVariant) {
        fillVariantFromPageState(triggerEl);
      }

      updateContextPreview();
    };

    const open = (triggerEl) => {
      // Cancel pending close if user reopens quickly.
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }

      lastActive = document.activeElement;

      fillFromTrigger(triggerEl);

      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);

      // Ensure transition plays.
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');

        // Focus first input (or close button fallback)
        const focusables = getFocusable();
        const first = focusables[0] || panel.querySelector('[data-email-concierge-close]');
        if (first) first.focus({ preventScroll: true });

        window.__FormSpamDefenseReset?.(drawer.querySelector('form'));
      });
    };

    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);

      const ms = getTransitionMs(panel);

      closeTimer = window.setTimeout(() => {
        drawer.hidden = true;
        closeTimer = null;

        if (lastActive && typeof lastActive.focus === 'function') {
          lastActive.focus({ preventScroll: true });
        }
      }, ms);
    };

    const handleKeydown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }

      if (e.key !== 'Tab') return;

      const focusables = Array.from(getFocusable());
      if (!focusables.length) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    drawerApi = { open, close, prefillMessageFromMailto, handleKeydown };
    return drawerApi;
  };

  // Delegated open/close
  document.addEventListener('click', (e) => {
    // 1) SITE-WIDE ACTIVATION: intercept mailto: links only
    const link = e.target.closest('a[href]');
    if (link && !drawer.contains(link) && !link.hasAttribute('data-email-concierge-bypass')) {
      const href = (link.getAttribute('href') || '').trim();
      const hrefLower = href.toLowerCase();

      if (hrefLower.startsWith('mailto:')) {
        const mailto = parseMailto(href);
        const isCoolingPage = window.location.pathname.replace(/\/$/, '').endsWith('/pages/cooling');

        if (isCoolingPage && mailto.to.toLowerCase() === 'one.world@msa.hinet.net') return;

        e.preventDefault();

        // Useful email metadata
        link.dataset.emailConciergeSource = mailto.to ? `mailto:${mailto.to}` : 'mailto';

        const api = getDrawerApi();

        // Optional: include subject/body into message box
        api.prefillMessageFromMailto(mailto);

        api.open(link);
        return;
      }
    }

    // 2) Manual activation still works for any element you tag (optional)
    const trigger = e.target.closest('[data-email-concierge-open]');
    if (trigger) {
      e.preventDefault();
      getDrawerApi().open(trigger);
      return;
    }

    // 3) Close handling (overlay / X / any close element)
    const closer = e.target.closest('[data-email-concierge-close]');
    if (closer && drawer.contains(closer)) {
      e.preventDefault();
      getDrawerApi().close();
    }
  });

  // ESC close + focus trap
  document.addEventListener('keydown', (e) => {
    if (drawer.hidden) return;
    getDrawerApi().handleKeydown(e);
  });

  // Auto-open after submit:
  // 1) Liquid marker (ideal)
  // 2) Fallback to Shopify’s contact_posted query param
  const url = new URL(window.location.href);
  const shouldAutoOpen =
    !!drawer.querySelector('[data-email-concierge-auto-open]') ||
    url.searchParams.get('contact_posted') === 'true';

  if (shouldAutoOpen) {
    getDrawerApi().open({ dataset: { emailConciergeSource: 'post_submit' } });

    // Prevent re-open on refresh by removing the param if present.
    if (url.searchParams.has('contact_posted')) {
      url.searchParams.delete('contact_posted');
      window.history.replaceState({}, '', url.toString());
    }
  }
})();
